/* eslint-disable valid-typeof */
import React from 'react';

import { Spacer, Text } from '@ontruck/orc';
import { FormatPrice } from 'utils/format';

const Price = ({
  changes: { currency_before, currency_after, net_full_price_before, net_full_price_after },
  ...props
}) => {
  if (typeof net_full_price_before === 'undefined' && typeof net_full_price_after === 'undefined') {
    return null;
  }

  return (
    <Spacer {...props}>
      <Text color="grey800" display="block">
        <FormatPrice currency={currency_before} value={net_full_price_before} />{' '}
        {typeof net_full_price_before !== undefined && <>&#8594;</>}{' '}
        <FormatPrice currency={currency_after} value={net_full_price_after} />
      </Text>
    </Spacer>
  );
};

export default Price;
